import * as ko from "knockout";
import * as _ from "underscore";

import {CONTROL_TYPES, SYSTEM_TABLE_NAMES, TABLE_TYPES} from "Core/Constant";
import { BaseProperty, IPropertyDescription } from "Core/GeneralProperties/Managers/BaseProperty";
import { IControl } from "Core/Controls/IControl";
import {RelationsToCopyEntityModel} from "Core/GeneralProperties/Managers/RelationsToCopyProperty/Models/EntityModel";
import {DesignScreen} from 'Core/Screens/DesignScreen/DesignScreen';
import {Notifier} from "Core/Common/Notifier";
import {EntityModel} from "../../../../QueryBuilder/Models/EntityModel";
import {RelationsToCopyPropertyStore} from "Core/GeneralProperties/Managers/RelationsToCopyProperty/Stores/RelationsToCopyPropertyStore";


import RelationsToCopyPropertyTemplate from 'Core/GeneralProperties/Managers/RelationsToCopyProperty/Template/RelationToCopyProperty.html';
ko.templates['Core/GeneralProperties/Managers/RelationsToCopyProperty/Template/RelationToCopyProperty'] = RelationsToCopyPropertyTemplate;
import RelationsToCopyPropertyIconTemplate from 'Core/GeneralProperties/Managers/RelationsToCopyProperty/Template/IconTemplate.html';
ko.templates['Core/GeneralProperties/Managers/RelationsToCopyProperty/Template/IconTemplate'] = RelationsToCopyPropertyIconTemplate;

export class RelationsToCopyProperty extends BaseProperty {
    private _control: IControl;
    private _showOptions: KnockoutObservable<boolean>;
    
    public Entities: KnockoutObservableArray<RelationsToCopyEntityModel>;
    public SelectedEntities: KnockoutObservableArray<RelationsToCopyEntityModel>;
    
    constructor(property: IPropertyDescription, propertyValue: string, control: IControl, getData: boolean = true) {
        super(property);

        this.Value = ko.observable(propertyValue || this.GetDefaultValue());
        
        this.Value([]);
        
        this._control = control;
        this._showOptions = ko.observable(true);
        
        this.Entities = ko.observableArray([]);
        this.SelectedEntities = ko.observableArray([]);

        this.Init(getData);

        this.IsEnabled.subscribe(newValue => {
            if (!newValue){
                this.DeselectEntities();
            }
        })
    }

    Init(getData: boolean = true) {
        if(getData) {
            this.GetDataRelationsToCopy();
        }
    }
    
    GetTemplateName(): string {
        return 'Core/GeneralProperties/Managers/RelationsToCopyProperty/Template/RelationToCopyProperty';
    }
    
    GetIconTemplateName(): string {
        return 'Core/GeneralProperties/Managers/RelationsToCopyProperty/Template/IconTemplate';
    }
    
    GetDefaultValue() {
        return null;
    }

    SelectEntity(entity: RelationsToCopyEntityModel) {
        if (!this.IsEnabled()) {
            return;
        }
        entity.SelectedStatus(true);
        this.SelectedEntities.push(entity);
        this.Value().push(entity.EntityId);
    }

    DeselectEntity(entity: RelationsToCopyEntityModel) {
        entity.SelectedStatus(false);
        const filteredSelectedEntities = _.filter(this.SelectedEntities(), (selectedEntity: RelationsToCopyEntityModel) => {
            return selectedEntity.EntityId !== entity.EntityId;
        });
        this.Value(_.filter(this.Value(),
            (entityId: number) => {
                return entityId !== entity.EntityId;
            })
        );
        this.SelectedEntities(filteredSelectedEntities);
    }

    GetDataRelationsToCopy(): void {
        const relationsToCopyEntities = (this._control as any)._relationsToCopy;
        relationsToCopyEntities && relationsToCopyEntities.map((entityId)=> {
            this.Value().push(entityId);
        })
        
        let gridSubjectEntityId = null;
        const parentControl = this._control.GetParentControl();
        if(parentControl?.GetType() === CONTROL_TYPES.Grid){
            
            let fieldModel = _.find(parentControl.Fields, (field) => {
                return field.EntityTypeName === TABLE_TYPES.Entity
            });
            if (!fieldModel) {
                fieldModel = _.find(parentControl.Fields, (field) => {
                    return field.EntityTypeName === TABLE_TYPES.Sub
                });
            }
            gridSubjectEntityId = fieldModel.EntityId;
            
            RelationsToCopyPropertyStore.GetRelationsToCopyEntities(gridSubjectEntityId)
                .always(() => {})
                .fail((err) => new Notifier().Failed(err.message))
                .then(entities => {
                    this.MappedEntity(entities);
                })
            
        } else {
            const designScreen = this._control.GetForm().GetScreen() as DesignScreen;
            const relatedEntities:EntityModel[] = designScreen.SubjectEntity.RelatedEntities.Entities;

            this.MappedEntity(relatedEntities);
        }
    }

    MappedEntity(entities: Array<any>): void {
        this.Entities(
            _.filter(entities, (entity)=> entity.EntityName !== SYSTEM_TABLE_NAMES.SYS_USERS)
            .map((entity:EntityModel)=> {
                const mappedEntity = _.extend(entity, {
                    EntityId: entity.EntityId,
                    EntityName: entity.EntityName,
                    EntityTranslatedName: entity.EntityNameTranslation,
                    SelectedStatus: this.Value().indexOf(entity.EntityId) !== -1 ? ko.observable(true) : ko.observable(false),
                });

                this.Value().indexOf(entity.EntityId) !== -1 && this.SelectedEntities.splice(this.Value().indexOf(entity.EntityId), 1, mappedEntity);

                return mappedEntity;
            })
        );
    }

    DeselectEntities(): void{
        _.forEach(this.Entities(), (entity: RelationsToCopyEntityModel)=> {
            this.DeselectEntity(entity);
        })
    }
}